
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/story",
      function () {
        return require("private-next-pages/search/story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/story"])
      });
    }
  